import { render, staticRenderFns } from "./setServiceMsg.vue?vue&type=template&id=66c4e0c2&"
import script from "./setServiceMsg.vue?vue&type=script&lang=js&"
export * from "./setServiceMsg.vue?vue&type=script&lang=js&"
import style0 from "./setServiceMsg.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports